/**
 * Champs obligatoires (*) — source unique pour la validation et le blocage navigation.
 * Édition personnelle : onglets Infos personnels + Contacts.
 */
export const MEMBER_SELF_EDIT_REQUIRED_FIELDS = [
  'first_name',
  'last_name',
  'email',
  'phone',
];

/** Création / édition admin : inclut la date d'adhésion (onglet Adhésion). */
export const MEMBER_ADMIN_REQUIRED_FIELDS = [
  ...MEMBER_SELF_EDIT_REQUIRED_FIELDS,
  'join_date',
];

export function isMemberRequiredFieldsComplete(member, { selfEdit = true } = {}) {
  if (!member || typeof member !== 'object') return false;
  const fields = selfEdit ? MEMBER_SELF_EDIT_REQUIRED_FIELDS : MEMBER_ADMIN_REQUIRED_FIELDS;
  return fields.every((key) => Boolean(String(member[key] ?? '').trim()));
}

/** @deprecated alias — complétude membre (auto-édition). */
export function isMemberIdentificationComplete(member) {
  return isMemberRequiredFieldsComplete(member, { selfEdit: true });
}

export function getMemberRequiredMissingFields(member, { selfEdit = true } = {}) {
  if (!member || typeof member !== 'object') {
    return selfEdit ? [...MEMBER_SELF_EDIT_REQUIRED_FIELDS] : [...MEMBER_ADMIN_REQUIRED_FIELDS];
  }
  const fields = selfEdit ? MEMBER_SELF_EDIT_REQUIRED_FIELDS : MEMBER_ADMIN_REQUIRED_FIELDS;
  return fields.filter((key) => !String(member[key] ?? '').trim());
}

/** Routes accessibles sans fiche membre complète (champs requis). */
export function isMemberProfileCompletionExemptPath(pathname) {
  const path = String(pathname || '');
  if (!path) return true;
  if (path === '/profile/edit' || path.startsWith('/profile/edit/')) return true;
  if (path.startsWith('/portal')) return true;
  return false;
}

export function needsProfileCompletionBanner(locationState) {
  return Boolean(
    locationState?.requireProfileCompletion || locationState?.fromFirstLogin
  );
}
